import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { ConnectorItemEntity } from '../components/connector-list/connector-item.entity';
import { ConnectorListEntity } from '../components/connector-list/connector-list.entity';
import {
	ConnectorOriginalSliceState,
	ConnectorSliceKey,
} from './connector.state';
import { ConnectorRootState, featureSelector } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[ConnectorSliceKey]
);

const isPublicProjectDetailsLoadingSelector = createSelector(
	baseSelector,
	(state) => state.isLoadingPublicProjectDetails
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const connectorById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class ConnectorSelector {
	public constructor(private readonly store: Store<ConnectorRootState>) {}

	private get state(): Observable<ConnectorOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getConnectorList$(): Observable<ConnectorListEntity> {
		return this.store.pipe(select(listSelector));
	}

	public includePublic$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('includePublicProjects')));
	}

	public isPublicProjectDetailsLoading$(): Observable<boolean> {
		return this.store.pipe(select(isPublicProjectDetailsLoadingSelector));
	}

	public getConnector$(
		id: number
	): Observable<ConnectorItemEntity | undefined> {
		return this.store.pipe(select(connectorById(id)));
	}

	public getSelectedConnectors$(
		selected: Array<string>
	): Observable<Array<ConnectorItemEntity>> {
		return this.getConnectorList$().pipe(
			map((list) =>
				selected.reduce<Array<ConnectorItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
